<template>
  <div class="history_center_con">
    <van-list
      v-model="loading"
      :finished="finished"
      :error.sync="loadError"
      :immediate-check="false"
      :offset="30"
      error-text="请求失败，点击重新加载"
      finished-text="没有更多了"
      @load="handleLoadMore"
    >
      <div v-for="(item, i) in listData" :key="i" class="point_list_item">
        <div class="point_img_con">
          <img
            class="full_img"
            :src="
              item.Details[0] && item.Details[0].ProductImageUrl
                ? item.Details[0].ProductImageUrl
                : $root.defaultImg
            "
            alt=""
          />
        </div>
        <div class="point_right_con f-1 f-cl">
          <div>
            <div class="c-ft-28 m-b-20 c-black bold">
              {{ item.Details[0] && item.Details[0].ProductName }}
            </div>
            <div class="c-ft-23 f-bt">
              <div>
                <span>兑换价：</span>
                <span>{{ item.FactPayIntegral }}分</span>
                <!-- <span v-if="item.Price">+</span>
                <span v-if="item.Price">{{ item.Price }}</span> -->
              </div>
              <div>数量：{{ item.Details[0] && item.Details[0].Quantity }}</div>
            </div>
          </div>
          <div class="f-bt">
            <div class="c-ft-23">{{ item.CreateTime }}</div>
            <div v-if="item.Status.Id === 1">
              <van-button
                color="var(--tc)"
                size="small"
                round
                @click="handleShowUseCode(item)"
                >兑换码</van-button
              >
            </div>
            <div v-else class="c-ft-23">
              {{ item.Status.Name }}
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <!-- <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :immediate-check="false"
      :offset="30"
      @load="handleLoadMore"
    >
      
    </van-list> -->
    <!-- <div v-else>
      <gNoContent title="暂无兑换记录"></gNoContent>
    </div> -->

    <van-dialog
      title="商品兑换码"
      v-model="showQr"
      show-cancel-button
      cancelButtonText="关闭"
      :show-confirm-button="false"
      @close="hideModel"
    >
      <div class="p-26 c-fc-center code_con">
        <div
          class="code-box"
          v-for="(subItem, subIndex) in qrCodeList"
          :key="subIndex"
        >
          <vue-qr :text="subItem.Code.toString()" class="qr_code"></vue-qr>
        </div>
        <p>兑换时向收银员出示此码兑换后失效</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
// import {receiveCoupon} from '@/api/coupon'
import { getUserOrderList } from "@/api/order";

import { Toast } from "vant";
import { getUserCouponList, transferMyTicket } from "@/api/coupon";
import wxConfig from "@/utils/wxConfig.js";
import shareOverlay from "@/components/shareOverlay/index.vue";
export default {
  name: "CouponsListCom",
  // props: {
  //   listData: {
  //     type: Array,
  //     default: () => {
  //       return [];
  //     },
  //   },
  // },
  data() {
    return {
      listData: [],
      pageIndex: 1,
      pageSize: 10,
      allPage: 0,
      loading: false,
      refreshing: false,
      finished: false,
      loadError: false,
      showRule: false,
      showQr: false,
      qrCodeList: [],
      couponLimit: [],
    };
  },

  mounted() {
    // ;
  },

  created() {
    this.loading = true;

    this.handleGetList();
  },
  methods: {
    // 获取优惠券列表
    handleGetList(flag) {
      // this.listData = [
      //   {
      //     ProductId: "299792497",
      //     TicketName: "商品aaaaa山东济南还是女孩简单",
      //     Price: 10,
      //     Integal: 100,
      //     imgUrl:
      //       "http://saas-ticket.oss-cn-beijing.aliyuncs.com/299792460/c72Y8DY6Xd.jpeg",
      //     TicketCode: 1111,
      //     OperateDate: "2023-03-08 12:23:45",
      //     Count: 1,
      //     QcodeWatermark: "已过期",
      //   },
      //   {
      //     ProductId: "299792497",
      //     TicketName: "清华池修脚",
      //     Price: 0,
      //     Integal: 200,
      //     imgUrl:
      //       " http://saas-ticket.oss-cn-beijing.aliyuncs.com/299792460/5hSynyJdEk.jpeg",
      //     TicketCode: 1111,
      //     Count: 1,
      //     OperateDate: "2023-03-08 12:23:45",
      //   },
      //   {
      //     ProductId: "299792497",
      //     TicketName: "商品aaaaa山东济南还是女孩简单",
      //     Price: 10,
      //     Integal: 100,
      //     imgUrl:
      //       "http://saas-ticket.oss-cn-beijing.aliyuncs.com/299792460/fTtKtKaS24.jpeg",
      //     TicketCode: 1111,
      //     OperateDate: "2023-03-08 12:23:45",
      //     Count: 2,
      //   },
      // ];
      getUserOrderList({
        query: { EventTypeId: 6 },
        pager: { pageindex: this.pageIndex, pagesize: this.pageSize },
      })
        .then((res) => {
          // console.log(res)
          let data = res.Items;

          // 判断订单是否支持退款
          // data.map((subItem) => {
          //   subItem.IsAllowRefund = subItem.Details.some(
          //     (innerItem) => innerItem.ProductIsAllowRefund
          //   );
          // });
          this.listData = this.listData.concat(data);

          this.allPage = res.Pager.TotalPage;

          //   // 数据全部加载完成
          if (this.listData.length >= res.Pager.TotalCount) {
            this.finished = true;
          }
          //   // 加载状态结束
          this.loading = false;
        })
        .catch((err) => {
          // console.log(err)
          this.loadError = true;
          this.loading = false;
          this.finished = true;
        });
      // });
    },
    handleLoadMore() {
      this.pageIndex += 1;
      this.handleGetList();
    },

    handleShowUseCode(v) {
      // let id = v.TicketCode;
      // this.$http(`discountticket/qrcode?code=${id}`).then(res => {
      // this.qrCode = 'data:image/png;base64,' + res.CodeDataSrc
      this.qrCodeList =
        v.Details[0] && v.Details[0].Tickets ? v.Details[0].Tickets : [];
      this.showQr = true;
      // })
    },

    hideModel() {
      this.showQr = false;
    },
  },
};
</script>
<style scoped lang="scss">
.history_center_con {
  background: #f3f5f9;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 30px;
}
.point_list_item {
  display: flex;
  background: #fff;

  border-radius: 30px;
  margin-bottom: 20px;
  overflow: hidden;

  .point_img_con {
    width: 180px;
    height: 180px;
  }
  .point_right_con {
    padding: 20px 20px 15px;
  }
  // .point_name_con {
  //   margin-bottom: 10px;
  //   text-overflow: ellipsis;
  //   overflow: hidden;
  //   white-space: nowrap;
  // }
}
.code_con {
  max-height: 70vh;
  overflow: auto;

  .qr_code {
    width: 350px;
  }
}
</style>
